module.exports = __webpack_public_path__ + "img/gift.edb071ee.png";